import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-razorpay-logo',
  templateUrl: './razorpay-logo.component.html',
  styleUrls: ['./razorpay-logo.component.scss']
})
export class RazorpayLogoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
